import { Component, EventEmitter, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-personal-data',
  templateUrl: './personalData.html',
  styleUrls: ['./personalData.scss'],
})
export class PersonalData {
  @Output() nextButtonClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() previousButtonClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() personalDataSubmitted: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
  }
  emitNextButtonClick() {
    this.nextButtonClick.emit();
  }

  emitPreviousButtonClick() {
    this.previousButtonClick.emit();
  }
}
